import styled from 'styled-components';

const CardsEffectSliderStyle = styled.div`
	--cesImageWidth: 33%;
	--cesImageProportion: 123%;
	--cesBorderSize: calc(var(--sp1x) / 2);

	.ces-container {
		position: relative;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		width: var(--cesImageWidth);

		.ces-inner-container {
			width: 100%;
			padding-top: var(--cesImageProportion);

			.ces-item {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				z-index: 1;

				border-radius: var(--sp2x);
				overflow: hidden;

				&.active {
					z-index: 2;
				}

				.imageCont {
					--imagePaddingTop: 0;

					height: 100%;
					border-radius: var(--sp2x);
					overflow: hidden;
					border: var(--cesBorderSize) solid var(--secondaryColor1);
				}
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--cesImageWidth: 33.28%;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--cesImageWidth: 32.98%;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--cesImageWidth: 33.2%;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--cesImageWidth: 29.68%;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--cesImageWidth: 31.25%;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--cesImageWidth: 41.66%;
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--cesImageWidth: 65.21%;
	}
`;

export default CardsEffectSliderStyle;
